import { render, staticRenderFns } from "./CarConfig.vue?vue&type=template&id=33090f8f&"
import script from "./CarConfig.vue?vue&type=script&lang=js&"
export * from "./CarConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports